import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "story-checkbox-input" }
const _hoisted_2 = ["checked", "aria-checked", "id", "value", "disabled"]
const _hoisted_3 = ["for"]
const _hoisted_4 = ["src"]

import { computed, PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'StoryCheckboxInput',
  props: {
    modelValue: { 
        type: Array as PropType<string[]>,
        required: true 
    },
    label: String,
    icon: String,
    id: String,
    inputValue: { 
        type: String,
        required: true 
    },
    disabled: Boolean
},
  emits: ["update:modelValue"],
  setup(__props, { emit }: { emit: ({
    (event: 'update:modelValue', payload: string[] | string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const isChecked = computed(() => {
    if (props.modelValue instanceof Array) {
        return props.modelValue.includes(props.inputValue)
    }
    return props.modelValue;
})

const updateValue = function () {
    const model = props.modelValue

    if (model instanceof Array) {
        const index = model.indexOf(props.inputValue)
        
        if (index === -1) {
            model.push(props.inputValue)
        } else {
            model.splice(index, 1)
        }
    }
    else {
        emit('update:modelValue', props.inputValue)
        return
    }

    emit('update:modelValue', model)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "checkbox",
      checked: _unref(isChecked),
      "aria-checked": _unref(isChecked),
      id: __props.id,
      value: __props.inputValue,
      onInput: updateValue,
      disabled: __props.disabled
    }, null, 40, _hoisted_2),
    _createElementVNode("label", { for: __props.id }, [
      _createElementVNode("span", null, [
        (__props.icon)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "rounded-circle",
              src: __props.icon,
              alt: ""
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _createTextVNode(" " + _toDisplayString(__props.label), 1)
    ], 8, _hoisted_3)
  ]))
}
}

})